// extracted by mini-css-extract-plugin
export default {"info":"ConfirmMarketingPreferencesPopup__info--3x0","inner":"ConfirmMarketingPreferencesPopup__inner--1t_"};